import { TOPSORT_USER_ID } from 'constants/browserStorageNames';
import { getCookie, setCookie } from 'cookies-next';
import { generateUUID } from 'utils/generateUUID';
import { browserLogger } from 'utils/logger/browserLogger';

const ONE_DAY_IN_SECONDS = 24 * 60 * 60;

let _sessionUserId: string | null = null;

const getCookieOptions = () => {
  const isProduction =
    process.env.APP_ENVIRONMENT === 'production' ||
    process.env.NODE_ENV === 'production';

  return {
    maxAge: ONE_DAY_IN_SECONDS,
    path: '/',
    ...(isProduction ? { domain: '.sympla.com.br' } : {})
  };
};

const persistTopsortUserId = (userId: string) => {
  setCookie(TOPSORT_USER_ID, userId, getCookieOptions());

  const persistedUserId = getCookie(TOPSORT_USER_ID);
  if (persistedUserId !== userId) {
    browserLogger().error({
      message: 'Failed to persist Topsort User ID in cookie.',
      data: `Expected: ${userId}, Got: ${persistedUserId}`
    });
  }
};

export const getExistingTopsortUserId = () => {
  const fromCookie = getCookie(TOPSORT_USER_ID);
  if (typeof fromCookie === 'string' && fromCookie) {
    _sessionUserId = fromCookie;
    return fromCookie;
  }

  const fromSDK =
    typeof window !== 'undefined' ? window.TS?.getUserId?.() : null;
  if (fromSDK) {
    _sessionUserId = fromSDK;
    return fromSDK;
  }

  if (_sessionUserId) return _sessionUserId;

  return null;
};

export const getTopsortUserId = () => {
  const cookieUserId = getCookie(TOPSORT_USER_ID);
  const existingUserId = getExistingTopsortUserId();

  if (existingUserId) {
    if (!cookieUserId) {
      persistTopsortUserId(existingUserId);
    }
    return existingUserId;
  }

  const newId = generateUUID();
  _sessionUserId = newId;
  persistTopsortUserId(newId);

  return newId;
};
